import styled from '@emotion/styled/macro';
import { FormattedMessage } from 'react-intl';
import { Flex, Button, Text } from '@chakra-ui/react';

import { getStudyStatusStyle } from '../../services/studies';

const StudyTrackerName = ({ value, data, valueFormatted, onStudyInfoModalOpen }) => {
    const status = getStudyStatusStyle(data.status);

    return (
        <Flex justifyContent="space-between" alignItems="center" w="100%">
            <TextWrapper>
                <Text color={status.style.nameColor} fontWeight="normal">
                    {valueFormatted ? valueFormatted : value}
                </Text>
            </TextWrapper>

            <Button variant="secondary-special" textTransform="capitalize" onClick={() => onStudyInfoModalOpen(data)}>
                <FormattedMessage id="study_tracker_info_column_btn" />
            </Button>
        </Flex>
    );
};

const TextWrapper = styled.div`
    align-self: flex-start;
    max-width: 400px;
    overflow: hidden;
    white-space: normal;
    line-height: 20px;
    padding-top: 2px;
`;

export default StudyTrackerName;
